import utils from "../../../utils/utils.js";

export default {

    async fetchSources(context) {
        const responseData = await utils.utility.fetch(
            `api/Setting/GetWorkspaceSources`,
            "GET",
            null,
            null
        );

        const mapped = responseData.data.map(option => ({
            id: option.id,
            text: option.name,
        }));
        context.commit("setSources", mapped);
    },
    async fetchWorkspaceSources(context) {

        const responseData = await utils.utility.fetch(
            `api/Setting/GetWorkspaceSources`,
            "GET",
            null,
            null
        );
        context.commit("setWorkspaceSources", responseData.data);
    }
}